import React, { ReactElement } from 'react'

import DataProviderTerms from '../components/terms/DataProcessingAgreement'
import { CompanyReducer } from '../reducers/companies'
import { connectToReducer } from '../utils/reducer-utils'

type Reducers = {
  companies: CompanyReducer
}

function DataProviderTermsContainer(props: Reducers): ReactElement | null {
  return <DataProviderTerms company={props.companies.company} />
}

export default connectToReducer<Reducers, any>(
  (state) => ({
    companies: state.companies,
  }),
  {}
)(DataProviderTermsContainer)
